module.exports = __webpack_public_path__ + "img/mixdragon.22e33cdd.png";